import type { ChatRuntime } from './runtime';

export type ChatApiError = {
  status: number;
  data: unknown;
};

type ChatEnvelope<T> = {
  success: boolean;
  message: string;
  data: T;
};

export async function chatRequest<T>(
  runtime: ChatRuntime,
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const fetchImpl = runtime.fetchImpl ?? fetch;
  const token = await runtime.getAccessToken?.();

  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const body = init.body;
  const isFormData = body instanceof FormData || Object.prototype.toString.call(body) === '[object FormData]';

  if (body && !isFormData) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetchImpl(`${runtime.baseUrl}${path}`, {
    ...init,
    credentials: 'include',
    headers,
  });

  let payload: unknown = null;

  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    throw {
      status: response.status,
      data: payload,
    } satisfies ChatApiError;
  }

  if (payload && typeof payload === 'object' && 'data' in (payload as Record<string, unknown>)) {
    return (payload as ChatEnvelope<T>).data;
  }

  return payload as T;
}
